import { Injectable } from "@angular/core";
import { Contract } from "@edp-components/edp-contract";
import { IHouseEnergyComparisonPayload } from "@edp-models/energy-comparison.model";
import { EnergyComparisonService } from "@edp-services/energy-comparison.service";
import { EDefineHouseActions, GetHouseEnergyComparison, SetHouseEnergyComparison } from "@edp-store/actions/define-house.action";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { getHouseEnergyComparison } from "@edp-store/selectors/define-house.selector";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { EMPTY, of } from "rxjs";
import { catchError, map, switchMap, take, tap } from "rxjs/operators";

@Injectable()
export class EnergyComparisonEffects {
    @Effect()
    $loadContractDataEnergyComparasiont = this.actions$.pipe(
        ofType(EDefineHouseActions.GetHouseEnergyComparison), 
        switchMap((action: GetHouseEnergyComparison) =>
            this.store.pipe(
                select(getContract),
                take(1),
                switchMap((contract: Contract | null) => {
                    if (contract) {
                        const contractCpe = contract.getEnergyCPE();
                        if (action.payload.forceRequest) {
                            return this.getEnergyComparison({...action.payload, CPE: contractCpe});
                        }else {
                            return this.store.pipe(
                                select(getHouseEnergyComparison),
                                take(1),
                                switchMap((energyComparasion) => {
                                    if (energyComparasion) {
                                        return of(new SetHouseEnergyComparison(energyComparasion));
                                    } else {
                                        return this.getEnergyComparison({...action.payload, CPE: contractCpe});
                                    }
                                })
                            );
                        }
                    }
                    return EMPTY;
                })
            )
        )
    );

    constructor(
        private actions$: Actions,
        private store: Store<IAppState>,
        private energyComparisonService: EnergyComparisonService
    ) {}


    private getEnergyComparison(payload: IHouseEnergyComparisonPayload) {        
        return this.energyComparisonService.getEnergyComparison(payload).pipe(
            map(data => new SetHouseEnergyComparison(data)),
            catchError(error => {
                console.error("Error request energy comparison", error);
                return EMPTY;
            })
        );
    }

}
